
import platformClient from 'purecloud-platform-client-v2'
import genesysCloudService from '@/services/genesyscloud-service'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'QueueList',
  data () {
    return {
      queues: [] as platformClient.Models.Queue[],
      selectedOption: ''
    }
  },
  methods: {
    onChange (event: Event) {
      if (event.target) {
        const queueId = (event.target as HTMLInputElement).value
        this.$emit('queueSelected', queueId)
      }
    }
  },
  emits: ['queueSelected'],
  created () {
    genesysCloudService.getQueues()
      .then(queues => {
        if (queues) this.queues = queues
      })
      .catch(err => console.error(err))
  }
})
